let DataDict = {
	"date_type": [{
			"id": "1167",
			"label": "Today",
			"value": "0"
		},
		{
			"id": "1168",
			"label": "Days",
			"value": "1"
		}
	],
	"plant_unit_type": [{
			"id": "1340",
			"label": "kg",
			"value": "0"
		},
		{
			"id": "1341",
			"label": "t",
			"value": "1"
		},
		{
			"id": "1342",
			"label": "g",
			"value": "2"
		},
		{
			"id": "1343",
			"label": "Unit",
			"value": "3"
		},
		{
			"id": "1344",
			"label": "Piece",
			"value": "4"
		},
		{
			"id": "1345",
			"label": "Slice",
			"value": "5"
		},
		{
			"id": "1346",
			"label": "Block",
			"value": "6"
		},
		{
			"id": "1347",
			"label": "Plant",
			"value": "7"
		},
		{
			"id": "1348",
			"label": "Head",
			"value": "8"
		},
		{
			"id": "1349",
			"label": "Pack",
			"value": "9"
		},
		{
			"id": "1350",
			"label": "Bag",
			"value": "10"
		},
		{
			"id": "1351",
			"label": "Basket",
			"value": "11"
		},
		{
			"id": "1352",
			"label": "Cart",
			"value": "12"
		}
	],
	"divide_exe_state": [{
			"id": "1097",
			"label": "Pending",
			"value": "0"
		},
		{
			"id": "1098",
			"label": "Completed",
			"value": "1"
		},
		{
			"id": "1099",
			"label": "Paused",
			"value": "2"
		},
		{
			"id": "1100",
			"label": "Failed",
			"value": "3"
		}
	],
	"execute_type": [{
			"id": "1050",
			"label": "Execute Now",
			"value": "0"
		},
		{
			"id": "1051",
			"label": "Schedule",
			"value": "1"
		}
	],
	"repayment_method": [{
			"id": "1226",
			"label": "Equal Principal & Interest",
			"value": "0"
		},
		{
			"id": "1227",
			"label": "Equal Principal",
			"value": "1"
		},
		{
			"id": "1228",
			"label": "Interest First",
			"value": "2"
		},
		{
			"id": "1229",
			"label": "Flexible Repayment",
			"value": "3"
		},
		{
			"id": "1230",
			"label": "Lump-Sum Payment",
			"value": "4"
		}
	],
	"audit_status": [{
			"id": "1469",
			"label": "No Review",
			"value": "0"
		},
		{
			"id": "1470",
			"label": "Review Required",
			"value": "1"
		}
	],
	"order_state_type": [{
			"id": "1065",
			"label": "Pending Confirmation",
			"value": "0"
		},
		{
			"id": "1066",
			"label": "Pending Payment",
			"value": "1"
		},
		{
			"id": "1067",
			"label": "Pending Shipment",
			"value": "2"
		},
		{
			"id": "1068",
			"label": "Pending Delivery",
			"value": "3"
		},
		{
			"id": "1069",
			"label": "Completed",
			"value": "4"
		},
		{
			"id": "1070",
			"label": "Canceled",
			"value": "5"
		},
		{
			"id": "1071",
			"label": "After-Sale Processing",
			"value": "6"
		},
		{
			"id": "1072",
			"label": "Pending Stock Preparation",
			"value": "7"
		},
		{
			"id": "1073",
			"label": "Pending Pickup",
			"value": "8"
		},
		{
			"id": "1074",
			"label": "Pending Review",
			"value": "9"
		}
	],
	"exam_invo_diss_type": [{
			"id": "1197",
			"label": "No Dispute",
			"value": "0"
		},
		{
			"id": "1198",
			"label": "Disputed",
			"value": "1"
		}
	],
	"order_state_provider": [{
			"id": "1518",
			"label": "Pending Confirmation",
			"value": "0"
		},
		{
			"id": "1519",
			"label": "Pending Service",
			"value": "2"
		},
		{
			"id": "1520",
			"label": "Service in Progress",
			"value": "3"
		},
		{
			"id": "1521",
			"label": "Completed",
			"value": "4"
		},
		{
			"id": "1522",
			"label": "Canceled",
			"value": "5"
		}
	],
	"product_spec_type": [{
			"id": "1109",
			"label": "Single Specification",
			"value": "0"
		},
		{
			"id": "1110",
			"label": "Multiple Specifications",
			"value": "1"
		}
	],
	"time_unit_type": [{
			"id": "1194",
			"label": "Minute",
			"value": "0"
		},
		{
			"id": "1195",
			"label": "Hour",
			"value": "1"
		},
		{
			"id": "1196",
			"label": "Day",
			"value": "2"
		}
	],
	"memb_coupon_status": [{
			"id": "1514",
			"label": "Frozen",
			"value": "0"
		},
		{
			"id": "1515",
			"label": "Unused",
			"value": "1"
		},
		{
			"id": "1516",
			"label": "Used",
			"value": "2"
		},
		{
			"id": "1517",
			"label": "Expired",
			"value": "3"
		}
	],
	"farm_dict_type": [{
			"id": "1379",
			"label": "Weight Unit",
			"value": "0"
		},
		{
			"id": "1380",
			"label": "Common Unit",
			"value": "1"
		},
		{
			"id": "1381",
			"label": "Volume Unit",
			"value": "2"
		},
		{
			"id": "1382",
			"label": "Vaccination Item",
			"value": "4"
		},
		{
			"id": "1383",
			"label": "Vaccination Method",
			"value": "5"
		},
		{
			"id": "1384",
			"label": "Vaccination Site",
			"value": "6"
		},
		{
			"id": "1385",
			"label": "Medication Method",
			"value": "7"
		},
		{
			"id": "1386",
			"label": "Poultry Type",
			"value": "8"
		}
	],
	"product_price_show_type": [{
			"id": "1286",
			"label": "Show Price to All Users",
			"value": "0"
		},
		{
			"id": "1287",
			"label": "Hide Price for Guests",
			"value": "1"
		}
	],
	"sync_type": [{
			"id": "1152",
			"label": "Sync Products",
			"value": "0"
		},
		{
			"id": "1153",
			"label": "Sync Orders",
			"value": "1"
		},
		{
			"id": "1154",
			"label": "Sync Order Status",
			"value": "2"
		}
	],
	"trace_call_method": [{
			"id": "1473",
			"label": "GET",
			"value": "0"
		},
		{
			"id": "1474",
			"label": "POST",
			"value": "1"
		}
	],
	"indust_standard_type": [{
			"id": "1490",
			"label": "Unlimited",
			"value": "0"
		},
		{
			"id": "1491",
			"label": "Organic",
			"value": "1"
		},
		{
			"id": "1492",
			"label": "Green",
			"value": "2"
		}
	],
	"url_type": [{
			"id": "1171",
			"label": "Image",
			"value": "0"
		},
		{
			"id": "1172",
			"label": "Video",
			"value": "1"
		}
	],
	"plant_situation_type": [{
			"id": "1373",
			"label": "Pest Damage",
			"value": "0"
		},
		{
			"id": "1374",
			"label": "Disease",
			"value": "1"
		},
		{
			"id": "1375",
			"label": "Weed Infestation",
			"value": "2"
		},
		{
			"id": "1376",
			"label": "Natural Disaster",
			"value": "3"
		}
	],
	"colle_meth_type": [{
			"id": "1280",
			"label": "Per Instance",
			"value": "0"
		},
		{
			"id": "1281",
			"label": "Percentage",
			"value": "1"
		}
	],
	"credit_type": [{
			"id": "1282",
			"label": "Active",
			"value": "0"
		},
		{
			"id": "1283",
			"label": "Frozen",
			"value": "1"
		}
	],
	"trace_call_status": [{
			"id": "1481",
			"label": "Failed",
			"value": "0"
		},
		{
			"id": "1482",
			"label": "Success",
			"value": "1"
		}
	],
	"generate_file_type": [{
			"id": "1131",
			"label": "PDF",
			"value": "0"
		},
		{
			"id": "1132",
			"label": "Excel",
			"value": "1"
		}
	],
	"drm_type": [{
			"id": "1035",
			"label": "Platform",
			"value": "0"
		},
		{
			"id": "1036",
			"label": "Merchant",
			"value": "1"
		}
	],
	"sf_late_fee_flag": [{
			"id": "1288",
			"label": "Yes",
			"value": "0"
		},
		{
			"id": "1289",
			"label": "No",
			"value": "1"
		}
	],
	"sync_status": [{
			"id": "1155",
			"label": "Sync Failed",
			"value": "0"
		},
		{
			"id": "1156",
			"label": "Sync Success",
			"value": "1"
		}
	],
	"base_equ_type": [{
			"id": "1319",
			"label": "IoT Device",
			"value": "0"
		},
		{
			"id": "1320",
			"label": "Video Device",
			"value": "1"
		}
	],
	"qms_report_value_type": [{
			"id": "1324",
			"label": "Free Text",
			"value": "0"
		},
		{
			"id": "1325",
			"label": "Database Field",
			"value": "1"
		}
	],
	"sex_type": [{
			"id": "1293",
			"label": "Male",
			"value": "0"
		},
		{
			"id": "1294",
			"label": "Female",
			"value": "1"
		},
		{
			"id": "1295",
			"label": "Other",
			"value": "2"
		}
	],
	"need_confirm_order_type": [{
			"id": "1046",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1047",
			"label": "Yes",
			"value": "1"
		}
	],
	"auth_status_type": [{
			"id": "1020",
			"label": "Draft",
			"value": "0"
		},
		{
			"id": "1021",
			"label": "Platform Reviewing",
			"value": "1"
		},
		{
			"id": "1022",
			"label": "Third-Party Reviewing",
			"value": "2"
		},
		{
			"id": "1023",
			"label": "Verification Failed",
			"value": "3"
		},
		{
			"id": "1024",
			"label": "Pending WeChat ID Verification",
			"value": "4"
		},
		{
			"id": "1025",
			"label": "Verified",
			"value": "5"
		},
		{
			"id": "1026",
			"label": "Revoked",
			"value": "6"
		}
	],
	"recon_state_type": [{
			"id": "1199",
			"label": "Pending Mutual Reconciliation",
			"value": "0"
		},
		{
			"id": "1200",
			"label": "Pending Buyer Reconciliation",
			"value": "1"
		},
		{
			"id": "1201",
			"label": "Pending Merchant Reconciliation",
			"value": "2"
		},
		{
			"id": "1202",
			"label": "Reconciliation Dispute",
			"value": "3"
		},
		{
			"id": "1203",
			"label": "Reconciliation Completed",
			"value": "4"
		}
	],
	"platf_type": [{
			"id": "1301",
			"label": "Not Received",
			"value": "0"
		},
		{
			"id": "1302",
			"label": "Received",
			"value": "1"
		}
	],
	"auth_state_type": [{
			"id": "1018",
			"label": "Unverified",
			"value": "0"
		},
		{
			"id": "1019",
			"label": "Verified",
			"value": "1"
		}
	],
	"plant_massif_type": [{
			"id": "1328",
			"label": "Hills",
			"value": "0"
		},
		{
			"id": "1329",
			"label": "Field",
			"value": "1"
		},
		{
			"id": "1330",
			"label": "Greenhouse",
			"value": "2"
		},
		{
			"id": "1331",
			"label": "Hothouse",
			"value": "3"
		},
		{
			"id": "1332",
			"label": "Terraces",
			"value": "4"
		}
	],
	"qms_is_default": [{
			"id": "1377",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1378",
			"label": "Yes",
			"value": "1"
		}
	],
	"usage_scope": [{
			"id": "1507",
			"label": "Storewide",
			"value": "0"
		},
		{
			"id": "1508",
			"label": "Specific Categories",
			"value": "1"
		},
		{
			"id": "1509",
			"label": "Specific Products",
			"value": "2"
		}
	],
	"trace_service_type": [{
			"id": "1471",
			"label": "API",
			"value": "0"
		},
		{
			"id": "1472",
			"label": "File Import",
			"value": "1"
		}
	],
	"product_status_type": [{
			"id": "1101",
			"label": "Off Shelf",
			"value": "0"
		},
		{
			"id": "1102",
			"label": "On Shelf",
			"value": "1"
		},
		{
			"id": "1103",
			"label": "Discontinued",
			"value": "2"
		},
		{
			"id": "1104",
			"label": "Pending Review",
			"value": "3"
		},
		{
			"id": "1105",
			"label": "Rejected",
			"value": "4"
		}
	],
	"qms_template_type": [{
			"id": "1321",
			"label": "Inspection Template",
			"value": "0"
		},
		{
			"id": "1322",
			"label": "Finished Product Report",
			"value": "1"
		},
		{
			"id": "1323",
			"label": "Raw Material Report",
			"value": "2"
		}
	],
	"settle_bill_statue_type": [{
			"id": "1176",
			"label": "Pending Reconciliation",
			"value": "0"
		},
		{
			"id": "1177",
			"label": "Pending Settlement",
			"value": "1"
		},
		{
			"id": "1178",
			"label": "Settled",
			"value": "2"
		},
		{
			"id": "1179",
			"label": "Canceled",
			"value": "3"
		},
		{
			"id": "1180",
			"label": "Overdue",
			"value": "4"
		}
	],
	"plant_method_type": [{
			"id": "1353",
			"label": "Transplanting",
			"value": "0"
		},
		{
			"id": "1354",
			"label": "Sowing",
			"value": "1"
		}
	],
	"base_type": [{
			"id": "1157",
			"label": "Planting Base",
			"value": "0"
		},
		{
			"id": "1158",
			"label": "Breeding Base",
			"value": "1"
		},
		{
			"id": "1159",
			"label": "Processing Base",
			"value": "2"
		},
		{
			"id": "1160",
			"label": "Storage Base",
			"value": "3"
		},
		{
			"id": "1161",
			"label": "Seed Source Base",
			"value": "4"
		},
		{
			"id": "1162",
			"label": "Logistics Base",
			"value": "5"
		},
		{
			"id": "1163",
			"label": "Pasture Base",
			"value": "6"
		},
		{
			"id": "1164",
			"label": "Other Base",
			"value": "7"
		},
		{
			"id": "1165",
			"label": "Cooperative",
			"value": "8"
		},
		{
			"id": "1166",
			"label": "Industrial Park",
			"value": "9"
		}
	],
	"navigate_type": [{
			"id": "1391",
			"label": "Link",
			"value": "0"
		},
		{
			"id": "1392",
			"label": "Image",
			"value": "1"
		}
	],
	"place_type": [{
			"id": "1054",
			"label": "Incubation Origin",
			"value": "0"
		},
		{
			"id": "1055",
			"label": "Partner Origin",
			"value": "1"
		}
	],
	"qms_judge_result": [{
			"id": "1311",
			"label": "Qualified",
			"value": "0"
		},
		{
			"id": "1312",
			"label": "Unqualified",
			"value": "1"
		},
		{
			"id": "1313",
			"label": "Not Judged",
			"value": "2"
		}
	],
	"trace_service_status": [{
			"id": "1477",
			"label": "Enabled",
			"value": "0"
		},
		{
			"id": "1478",
			"label": "Enabled",
			"value": "1"
		}
	],
	"farm_vacmed_type": [{
			"id": "1387",
			"label": "Vaccine",
			"value": "0"
		},
		{
			"id": "1388",
			"label": "Medicine",
			"value": "1"
		}
	],
	"order_source_type": [{
			"id": "1063",
			"label": "WeChat Mini Program",
			"value": "0"
		},
		{
			"id": "1064",
			"label": "Web Platform",
			"value": "1"
		}
	],
	"auth_type": [{
			"id": "1027",
			"label": "Enterprise Verification",
			"value": "0"
		},
		{
			"id": "1028",
			"label": "Personal Verification",
			"value": "1"
		}
	],
	"qms_record_status": [{
			"id": "1307",
			"label": "Draft",
			"value": "0"
		},
		{
			"id": "1308",
			"label": "Completed",
			"value": "1"
		}
	],
	"pay_method_type": [{
			"id": "1075",
			"label": "Online Payment",
			"value": "0"
		},
		{
			"id": "1076",
			"label": "Offline Payment",
			"value": "1"
		},
		{
			"id": "1077",
			"label": "Credit Payment",
			"value": "2"
		}
	],
	"indust_supply_status": [{
			"id": "1485",
			"label": "Off Shelf",
			"value": "0"
		},
		{
			"id": "1486",
			"label": "On Shelf",
			"value": "1"
		}
	],
	"auto_sync_order": [{
			"id": "1395",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1396",
			"label": "Yes",
			"value": "1"
		}
	],
	"borrower": [{
			"id": "1221",
			"label": "Legal Person",
			"value": "0"
		},
		{
			"id": "1222",
			"label": "Enterprise",
			"value": "1"
		},
		{
			"id": "1223",
			"label": "10% Shareholder",
			"value": "2"
		},
		{
			"id": "1224",
			"label": "20% Shareholder",
			"value": "3"
		},
		{
			"id": "1225",
			"label": "Director/Supervisor/Executive",
			"value": "4"
		}
	],
	"enabled_status": [{
			"id": "1009",
			"label": "Disabled",
			"value": "0"
		},
		{
			"id": "1010",
			"label": "Enabled",
			"value": "1"
		}
	],
	"is_limited": [{
			"id": "1503",
			"label": "Limited Quantity",
			"value": "0"
		},
		{
			"id": "1504",
			"label": "Unlimited",
			"value": "1"
		}
	],
	"discount_type": [{
			"id": "1125",
			"label": "Overall Discount",
			"value": "0"
		},
		{
			"id": "1126",
			"label": "Custom Discount",
			"value": "1"
		}
	],
	"match_status": [{
			"id": "1150",
			"label": "Unmatched",
			"value": "0"
		},
		{
			"id": "1151",
			"label": "Matched",
			"value": "1"
		}
	],
	"link_type": [{
			"id": "1242",
			"label": "PC Link",
			"value": "0"
		},
		{
			"id": "1243",
			"label": "H5 Link",
			"value": "1"
		},
		{
			"id": "1244",
			"label": "QR Code",
			"value": "2"
		}
	],
	"generate_qrcode_tpye": [{
			"id": "1129",
			"label": "Product",
			"value": "0"
		},
		{
			"id": "1130",
			"label": "Store",
			"value": "1"
		}
	],
	"confirm_order_type": [{
			"id": "1052",
			"label": "Cart Confirmation",
			"value": "0"
		},
		{
			"id": "1053",
			"label": "Instant Purchase",
			"value": "1"
		}
	],
	"invo_state": [{
			"id": "1181",
			"label": "Pending Invoice",
			"value": "0"
		},
		{
			"id": "1182",
			"label": "Pending Verification",
			"value": "1"
		},
		{
			"id": "1183",
			"label": "Completed",
			"value": "2"
		}
	],
	"time_period": [{
			"id": "1457",
			"label": "0:00-6:00",
			"value": "0"
		},
		{
			"id": "1458",
			"label": "6:00-9:00",
			"value": "1"
		},
		{
			"id": "1459",
			"label": "9:00-12:00",
			"value": "2"
		},
		{
			"id": "1460",
			"label": "12:00-14:00",
			"value": "3"
		},
		{
			"id": "1461",
			"label": "14:00-16:00",
			"value": "4"
		},
		{
			"id": "1462",
			"label": "16:00-18:00",
			"value": "5"
		},
		{
			"id": "1463",
			"label": "18:00-21:00",
			"value": "6"
		},
		{
			"id": "1464",
			"label": "21:00-24:00",
			"value": "7"
		}
	],
	"template_status": [{
			"id": "1333",
			"label": "Disabled",
			"value": "0"
		},
		{
			"id": "1334",
			"label": "Enabled",
			"value": "1"
		}
	],
	"sub_led_flag": [{
			"id": "1290",
			"label": "Settled",
			"value": "0"
		},
		{
			"id": "1291",
			"label": "Unsettled",
			"value": "1"
		}
	],
	"from_platform": [{
			"id": "1133",
			"label": "Digital Store",
			"value": "0"
		},
		{
			"id": "1134",
			"label": "Digital Supply Chain",
			"value": "1"
		},
		{
			"id": "1135",
			"label": "Agent Order",
			"value": "2"
		},
		{
			"id": "1136",
			"label": "Third-Party Platform",
			"value": "3"
		},
		{
			"id": "1137",
			"label": "Douyin Store",
			"value": "4"
		},
		{
			"id": "1138",
			"label": "JD.com",
			"value": "5"
		},
		{
			"id": "1139",
			"label": "Pinduoduo",
			"value": "6"
		},
		{
			"id": "1140",
			"label": "Channel Order",
			"value": "7"
		},
		{
			"id": "1141",
			"label": "Taobao",
			"value": "8"
		},
		{
			"id": "1142",
			"label": "Pinduoduo",
			"value": "9"
		},
		{
			"id": "1143",
			"label": "Kuaishou",
			"value": "10"
		},
		{
			"id": "1144",
			"label": "WeChat Channels",
			"value": "11"
		},
		{
			"id": "1145",
			"label": "Weidian",
			"value": "12"
		},
		{
			"id": "1146",
			"label": "Taobao Specials",
			"value": "13"
		},
		{
			"id": "1147",
			"label": "Weibo Mall",
			"value": "14"
		},
		{
			"id": "1148",
			"label": "WeChat Store",
			"value": "15"
		},
		{
			"id": "1149",
			"label": "Suning",
			"value": "16"
		}
	],
	"pack_meth_type": [{
			"id": "1399",
			"label": "Carton",
			"value": "0"
		},
		{
			"id": "1400",
			"label": "Basket",
			"value": "1"
		},
		{
			"id": "1401",
			"label": "Bulk",
			"value": "2"
		},
		{
			"id": "1402",
			"label": "Pallet",
			"value": "3"
		},
		{
			"id": "1403",
			"label": "Bundle",
			"value": "4"
		},
		{
			"id": "1404",
			"label": "Bag",
			"value": "5"
		},
		{
			"id": "1405",
			"label": "Nude Packing",
			"value": "6"
		},
		{
			"id": "1406",
			"label": "Other",
			"value": "7"
		}
	],
	"source": [{
			"id": "1497",
			"label": "Web",
			"value": "0"
		},
		{
			"id": "1498",
			"label": "H5",
			"value": "1"
		}
	],
	"bill_date_type": [{
			"id": "1245",
			"label": "1",
			"value": "1"
		},
		{
			"id": "1246",
			"label": "2",
			"value": "2"
		},
		{
			"id": "1247",
			"label": "3",
			"value": "3"
		},
		{
			"id": "1248",
			"label": "4",
			"value": "4"
		},
		{
			"id": "1249",
			"label": "5",
			"value": "5"
		},
		{
			"id": "1250",
			"label": "6",
			"value": "6"
		},
		{
			"id": "1251",
			"label": "7",
			"value": "7"
		},
		{
			"id": "1252",
			"label": "8",
			"value": "8"
		},
		{
			"id": "1253",
			"label": "9",
			"value": "9"
		},
		{
			"id": "1254",
			"label": "10",
			"value": "10"
		},
		{
			"id": "1255",
			"label": "11",
			"value": "11"
		},
		{
			"id": "1256",
			"label": "12",
			"value": "12"
		},
		{
			"id": "1257",
			"label": "13",
			"value": "13"
		},
		{
			"id": "1258",
			"label": "14",
			"value": "14"
		},
		{
			"id": "1259",
			"label": "15",
			"value": "15"
		},
		{
			"id": "1260",
			"label": "16",
			"value": "16"
		},
		{
			"id": "1261",
			"label": "17",
			"value": "17"
		},
		{
			"id": "1262",
			"label": "18",
			"value": "18"
		},
		{
			"id": "1263",
			"label": "19",
			"value": "19"
		},
		{
			"id": "1264",
			"label": "20",
			"value": "20"
		},
		{
			"id": "1265",
			"label": "21",
			"value": "21"
		},
		{
			"id": "1266",
			"label": "22",
			"value": "22"
		},
		{
			"id": "1267",
			"label": "23",
			"value": "23"
		},
		{
			"id": "1268",
			"label": "24",
			"value": "24"
		},
		{
			"id": "1269",
			"label": "25",
			"value": "25"
		},
		{
			"id": "1270",
			"label": "26",
			"value": "26"
		},
		{
			"id": "1271",
			"label": "27",
			"value": "27"
		},
		{
			"id": "1272",
			"label": "28",
			"value": "28"
		},
		{
			"id": "1273",
			"label": "Monday",
			"value": "29"
		},
		{
			"id": "1274",
			"label": "Tuesday",
			"value": "30"
		},
		{
			"id": "1275",
			"label": "Wednesday",
			"value": "31"
		},
		{
			"id": "1276",
			"label": "Thursday",
			"value": "32"
		},
		{
			"id": "1277",
			"label": "Friday",
			"value": "33"
		},
		{
			"id": "1278",
			"label": "Saturday",
			"value": "34"
		},
		{
			"id": "1279",
			"label": "Sunday",
			"value": "35"
		}
	],
	"car_type": [{
			"id": "1436",
			"label": "Van",
			"value": "0"
		},
		{
			"id": "1437",
			"label": "Flatbed",
			"value": "1"
		},
		{
			"id": "1438",
			"label": "High Rail",
			"value": "2"
		},
		{
			"id": "1439",
			"label": "Refrigerated Truck",
			"value": "3"
		},
		{
			"id": "1440",
			"label": "Wing Van",
			"value": "4"
		},
		{
			"id": "1441",
			"label": "Open Top",
			"value": "5"
		},
		{
			"id": "1442",
			"label": "Removable Side",
			"value": "6"
		},
		{
			"id": "1443",
			"label": "Dump Truck",
			"value": "7"
		}
	],
	"map_type": [{
			"id": "1449",
			"label": "Enterprise Base",
			"value": "0"
		},
		{
			"id": "1450",
			"label": "Platform Base",
			"value": "1"
		}
	],
	"plant_show_type": [{
			"id": "1355",
			"label": "Image",
			"value": "0"
		},
		{
			"id": "1356",
			"label": "Video",
			"value": "1"
		}
	],
	"cust_type": [{
			"id": "1032",
			"label": "Enterprise Merchant",
			"value": "0"
		},
		{
			"id": "1033",
			"label": "Individual Merchant",
			"value": "1"
		},
		{
			"id": "1034",
			"label": "Institution",
			"value": "2"
		}
	],
	"plant_output_type": [{
			"id": "1360",
			"label": "Per Mu",
			"value": "0"
		},
		{
			"id": "1361",
			"label": "Per Plant",
			"value": "1"
		}
	],
	"qms_record_type": [{
			"id": "1309",
			"label": "Inbound Order",
			"value": "0"
		},
		{
			"id": "1310",
			"label": "Production Order",
			"value": "1"
		}
	],
	"trspot_cancel_order_type": [{
			"id": "1451",
			"label": "Already Booked Vehicle",
			"value": "0"
		},
		{
			"id": "1452",
			"label": "Vehicle Type Mismatch",
			"value": "1"
		},
		{
			"id": "1453",
			"label": "Customer Order Cancelled",
			"value": "2"
		},
		{
			"id": "1454",
			"label": "Incorrect Loading Time",
			"value": "3"
		},
		{
			"id": "1455",
			"label": "Customer Pickup",
			"value": "4"
		},
		{
			"id": "1456",
			"label": "Other Reasons",
			"value": "5"
		}
	],
	"invo_content_type": [{
			"id": "1284",
			"label": "Product Details",
			"value": "0"
		},
		{
			"id": "1285",
			"label": "Product Category",
			"value": "1"
		}
	],
	"refund_appl_state_type": [{
			"id": "1085",
			"label": "Pending Review",
			"value": "0"
		},
		{
			"id": "1086",
			"label": "Processing",
			"value": "1"
		},
		{
			"id": "1087",
			"label": "Rejected",
			"value": "2"
		},
		{
			"id": "1088",
			"label": "Completed",
			"value": "3"
		},
		{
			"id": "1089",
			"label": "Cancelled",
			"value": "4"
		}
	],
	"trace_param_type": [{
			"id": "1479",
			"label": "Latest Date",
			"value": "0"
		},
		{
			"id": "1480",
			"label": "Text",
			"value": "1"
		}
	],
	"auto_sync_product": [{
			"id": "1397",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1398",
			"label": "Yes",
			"value": "1"
		}
	],
	"default_flag": [{
			"id": "1056",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1057",
			"label": "Yes",
			"value": "1"
		}
	],
	"order_type": [{
			"id": "1061",
			"label": "Store Order",
			"value": "0"
		},
		{
			"id": "1062",
			"label": "B2B Order",
			"value": "1"
		}
	],
	"qms_samp_status": [{
			"id": "1314",
			"label": "Pending Test",
			"value": "0"
		},
		{
			"id": "1315",
			"label": "Testing",
			"value": "1"
		},
		{
			"id": "1316",
			"label": "Tested",
			"value": "2"
		}
	],
	"qms_copy_flag": [{
			"id": "1317",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1318",
			"label": "Yes",
			"value": "1"
		}
	],
	"memb_type": [{
			"id": "1011",
			"label": "Platform",
			"value": "0"
		},
		{
			"id": "1012",
			"label": "Production Base",
			"value": "1"
		},
		{
			"id": "1013",
			"label": "Merchant",
			"value": "2"
		},
		{
			"id": "1014",
			"label": "Mini Program Buyer",
			"value": "3"
		},
		{
			"id": "1015",
			"label": "Farmer",
			"value": "4"
		},
		{
			"id": "1016",
			"label": "B2B Buyer",
			"value": "5"
		},
		{
			"id": "1017",
			"label": "Logistics Driver",
			"value": "6"
		}
	],
	"deposit_pay_type": [{
			"id": "1539",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1540",
			"label": "Yes",
			"value": "1"
		}
	],
	"sf_yq_flag": [{
			"id": "1184",
			"label": "Yes",
			"value": "0"
		},
		{
			"id": "1185",
			"label": "No",
			"value": "1"
		}
	],
	"approval_status": [{
			"id": "1058",
			"label": "Pending Review",
			"value": "0"
		},
		{
			"id": "1059",
			"label": "Approved",
			"value": "1"
		},
		{
			"id": "1060",
			"label": "Rejected",
			"value": "2"
		}
	],
	"loan_period": [{
			"id": "1231",
			"label": "1 Month",
			"value": "0"
		},
		{
			"id": "1232",
			"label": "3 Months",
			"value": "1"
		},
		{
			"id": "1233",
			"label": "6 Months",
			"value": "2"
		},
		{
			"id": "1234",
			"label": "9 Months",
			"value": "3"
		},
		{
			"id": "1235",
			"label": "12 Months",
			"value": "4"
		},
		{
			"id": "1236",
			"label": "15 Months",
			"value": "5"
		},
		{
			"id": "1237",
			"label": "18 Months",
			"value": "6"
		},
		{
			"id": "1238",
			"label": "24 Months",
			"value": "7"
		},
		{
			"id": "1239",
			"label": "36 Months",
			"value": "8"
		},
		{
			"id": "1240",
			"label": "48 Months",
			"value": "9"
		},
		{
			"id": "1241",
			"label": "60 Months",
			"value": "10"
		}
	],
	"settle_cycle_type": [{
			"id": "1206",
			"label": "Weekly Settlement",
			"value": "0"
		},
		{
			"id": "1207",
			"label": "Monthly Settlement",
			"value": "1"
		}
	],
	"dead_line_type": [{
			"id": "1113",
			"label": "Seller confirmation period after buyer submits order",
			"value": "0"
		},
		{
			"id": "1114",
			"label": "Buyer payment period after seller confirms order",
			"value": "1"
		},
		{
			"id": "1115",
			"label": "Seller Stock preparation period after buyer payment",
			"value": "2"
		},
		{
			"id": "1116",
			"label": "Buyer self-pickup period after seller completes Stock preparation",
			"value": "3"
		},
		{
			"id": "1117",
			"label": "After-sales application period after buyer completes self-pickup",
			"value": "4"
		},
		{
			"id": "1118",
			"label": "Seller shipping period after buyer payment",
			"value": "5"
		},
		{
			"id": "1119",
			"label": "Buyer receiving period after seller ships order",
			"value": "6"
		},
		{
			"id": "1120",
			"label": "After-sales application period after buyer completes receipt",
			"value": "7"
		},
		{
			"id": "1121",
			"label": "Seller processing period after buyer applies for after-sales service",
			"value": "8"
		},
		{
			"id": "1122",
			"label": "Reconciliation period for both parties after account settlement statement reconciliation date",
			"value": "9"
		},
		{
			"id": "1123",
			"label": "Seller invoice issuance period after buyer applies for invoice on account settlement statement",
			"value": "10"
		},
		{
			"id": "1124",
			"label": "Buyer invoice verification period after seller issues invoice on account settlement statement",
			"value": "11"
		}
	],
	"ord_send_type": [{
			"id": "1095",
			"label": "Logistics Delivery",
			"value": "0"
		},
		{
			"id": "1096",
			"label": "Seller Delivery",
			"value": "1"
		}
	],
	"handle_result_type": [{
			"id": "1090",
			"label": "Approve",
			"value": "0"
		},
		{
			"id": "1091",
			"label": "Reject",
			"value": "1"
		}
	],
	"need_invo_type": [{
			"id": "1186",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1187",
			"label": "Yes",
			"value": "1"
		}
	],
	"cx_mode_type": [{
			"id": "1127",
			"label": "Web Query",
			"value": "0"
		},
		{
			"id": "1128",
			"label": "Mobile QR Code Query",
			"value": "1"
		}
	],
	"plant_is_flag": [{
			"id": "1362",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1363",
			"label": "Yes",
			"value": "1"
		}
	],
	"show_type": [{
			"id": "1393",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1394",
			"label": "Yes",
			"value": "1"
		}
	],
	"trspot_order_status_type": [{
			"id": "1444",
			"label": "Pending Acceptance",
			"value": "0"
		},
		{
			"id": "1445",
			"label": "Accepted",
			"value": "1"
		},
		{
			"id": "1446",
			"label": "In Transit",
			"value": "2"
		},
		{
			"id": "1447",
			"label": "Completed",
			"value": "3"
		},
		{
			"id": "1448",
			"label": "Canceled",
			"value": "4"
		}
	],
	"handle_method_type": [{
			"id": "1092",
			"label": "Order Refund",
			"value": "0"
		},
		{
			"id": "1093",
			"label": "Product Reshipment",
			"value": "1"
		},
		{
			"id": "1094",
			"label": "Reject",
			"value": "2"
		}
	],
	"invo_apply_status": [{
			"id": "1305",
			"label": "Pending Invoice",
			"value": "0"
		},
		{
			"id": "1306",
			"label": "Invoice Issued",
			"value": "1"
		}
	],
	"air_type": [{
			"id": "1169",
			"label": "Temperature",
			"value": "0"
		},
		{
			"id": "1170",
			"label": "Humidity",
			"value": "1"
		}
	],
	"refund_state_type": [{
			"id": "1082",
			"label": "Processing",
			"value": "0"
		},
		{
			"id": "1083",
			"label": "Refund Successful",
			"value": "1"
		},
		{
			"id": "1084",
			"label": "Refund Failed",
			"value": "2"
		}
	],
	"plant_work_type": [{
			"id": "1364",
			"label": "Transplanting",
			"value": "0"
		},
		{
			"id": "1365",
			"label": "Cultivation",
			"value": "1"
		},
		{
			"id": "1366",
			"label": "Soil Fertilizer",
			"value": "2"
		},
		{
			"id": "1367",
			"label": "Base Fertilization",
			"value": "3"
		},
		{
			"id": "1368",
			"label": "Pesticide",
			"value": "4"
		},
		{
			"id": "1369",
			"label": "Basic Fertilization",
			"value": "5"
		}
	],
	"shop_coupon_status": [{
			"id": "1510",
			"label": "Pending Activation",
			"value": "0"
		},
		{
			"id": "1511",
			"label": "Activated",
			"value": "1"
		},
		{
			"id": "1512",
			"label": "Expired",
			"value": "2"
		},
		{
			"id": "1513",
			"label": "Canceled",
			"value": "3"
		}
	],
	"plant_standard_type": [{
			"id": "1370",
			"label": "Organic",
			"value": "0"
		},
		{
			"id": "1371",
			"label": "Green",
			"value": "1"
		},
		{
			"id": "1372",
			"label": "Standard",
			"value": "2"
		}
	],
	"coupon_type": [{
		"id": "1499",
		"label": "Spend-and-Save Coupon",
		"value": "0"
	}],
	"trace_timing_status": [{
			"id": "1475",
			"label": "No",
			"value": "0"
		},
		{
			"id": "1476",
			"label": "Yes",
			"value": "1"
		}
	],
	"finance_product_status": [{
			"id": "1218",
			"label": "Pending Listing",
			"value": "0"
		},
		{
			"id": "1219",
			"label": "Listed",
			"value": "1"
		},
		{
			"id": "1220",
			"label": "Delisted",
			"value": "2"
		}
	],
	"plat_config_type": [{
			"id": "1527",
			"label": "Industry Platform Name",
			"value": "0"
		},
		{
			"id": "1528",
			"label": "Industry Platform Slogan",
			"value": "1"
		},
		{
			"id": "1529",
			"label": "Industry Platform Overview",
			"value": "2"
		},
		{
			"id": "1530",
			"label": "Industry Platform Background Image",
			"value": "3"
		},
		{
			"id": "1531",
			"label": "Industry Platform Logo",
			"value": "4"
		},
		{
			"id": "1532",
			"label": "Enterprise Platform Name",
			"value": "21"
		},
		{
			"id": "1533",
			"label": "Enterprise Platform Slogan",
			"value": "22"
		},
		{
			"id": "1534",
			"label": "Enterprise Platform Overview",
			"value": "23"
		},
		{
			"id": "1535",
			"label": "Enterprise Platform Background Image",
			"value": "24"
		},
		{
			"id": "1536",
			"label": "Enterprise Platform Logo",
			"value": "25"
		},
		{
			"id": "1537",
			"label": "Browser Icon",
			"value": "41"
		}
	],
	"tag_type": [{
			"id": "1173",
			"label": "Order Cancellation Reason",
			"value": "0"
		},
		{
			"id": "1174",
			"label": "After-sales Type",
			"value": "1"
		},
		{
			"id": "1175",
			"label": "Delivery Service",
			"value": "2"
		}
	],
	"car_length_type": [{
			"id": "1409",
			"label": "1.4m",
			"value": "0"
		},
		{
			"id": "1410",
			"label": "1.6m",
			"value": "1"
		},
		{
			"id": "1411",
			"label": "1.8m",
			"value": "2"
		},
		{
			"id": "1412",
			"label": "2.7m",
			"value": "3"
		},
		{
			"id": "1413",
			"label": "3.8m",
			"value": "4"
		},
		{
			"id": "1414",
			"label": "4.2m",
			"value": "5"
		},
		{
			"id": "1415",
			"label": "5m",
			"value": "6"
		},
		{
			"id": "1416",
			"label": "5.2m",
			"value": "7"
		},
		{
			"id": "1417",
			"label": "6.2m",
			"value": "8"
		},
		{
			"id": "1418",
			"label": "6.8m",
			"value": "9"
		},
		{
			"id": "1419",
			"label": "7.6m",
			"value": "10"
		},
		{
			"id": "1420",
			"label": "7.7m",
			"value": "11"
		},
		{
			"id": "1421",
			"label": "8.2m",
			"value": "12"
		},
		{
			"id": "1422",
			"label": "8.7m",
			"value": "13"
		},
		{
			"id": "1423",
			"label": "9.6m",
			"value": "14"
		},
		{
			"id": "1424",
			"label": "11.5m",
			"value": "15"
		},
		{
			"id": "1425",
			"label": "11.7m",
			"value": "16"
		},
		{
			"id": "1426",
			"label": "12m",
			"value": "17"
		},
		{
			"id": "1427",
			"label": "12.5m",
			"value": "18"
		},
		{
			"id": "1428",
			"label": "13m",
			"value": "19"
		},
		{
			"id": "1429",
			"label": "13.7m",
			"value": "20"
		},
		{
			"id": "1430",
			"label": "14m",
			"value": "21"
		},
		{
			"id": "1431",
			"label": "15m",
			"value": "22"
		},
		{
			"id": "1432",
			"label": "16m",
			"value": "23"
		},
		{
			"id": "1433",
			"label": "17.5m",
			"value": "24"
		},
		{
			"id": "1434",
			"label": "18.5m",
			"value": "25"
		},
		{
			"id": "1435",
			"label": "21m",
			"value": "26"
		}
	],
	"coupon_issue_type": [{
			"id": "1500",
			"label": "Operation Distribution",
			"value": "0"
		},
		{
			"id": "1501",
			"label": "Channel Distribution",
			"value": "1"
		},
		{
			"id": "1502",
			"label": "Online Distribution",
			"value": "2"
		}
	],
	"plant_planting_status": [{
			"id": "1357",
			"label": "Planned Planting",
			"value": "0"
		},
		{
			"id": "1358",
			"label": "Active Planting",
			"value": "1"
		},
		{
			"id": "1359",
			"label": "Completed Planting",
			"value": "2"
		}
	],
	"valid_type": [{
			"id": "1505",
			"label": "Specific Date",
			"value": "0"
		},
		{
			"id": "1506",
			"label": "Specific Days",
			"value": "1"
		}
	],
	"trans_mode_type": [{
		"id": "1292",
		"label": "Bulk Trading",
		"value": "0"
	}],
	"pay_type": [{
			"id": "1541",
			"label": "Full Payment",
			"value": "0"
		},
		{
			"id": "1542",
			"label": "Credit Payment",
			"value": "1"
		},
		{
			"id": "1543",
			"label": "Deposit Payment",
			"value": "2"
		}
	],
	"bank_account_type": [{
			"id": "1029",
			"label": "Corporate Settlement Card",
			"value": "0"
		},
		{
			"id": "1030",
			"label": "Corporate Account",
			"value": "1"
		},
		{
			"id": "1031",
			"label": "Debit Card",
			"value": "2"
		}
	],
	"settle_bill_prdut_type": [{
			"id": "1208",
			"label": "System Generated",
			"value": "0"
		},
		{
			"id": "1209",
			"label": "Early Settlement",
			"value": "1"
		}
	],
	"delivery_method_type": [{
			"id": "1106",
			"label": "Seller Delivery",
			"value": "0"
		},
		{
			"id": "1107",
			"label": "Buyer Pickup",
			"value": "1"
		},
		{
			"id": "1108",
			"label": "Logistics Delivery/Store Pickup",
			"value": "2"
		}
	],
	"publish_status": [{
			"id": "1465",
			"label": "Under Review",
			"value": "0"
		},
		{
			"id": "1466",
			"label": "Pending Publication",
			"value": "1"
		},
		{
			"id": "1467",
			"label": "Published",
			"value": "2"
		},
		{
			"id": "1468",
			"label": "Rejected",
			"value": "3"
		}
	],
	"settle_bill_generate_type": [{
			"id": "1204",
			"label": "Generated",
			"value": "0"
		},
		{
			"id": "1205",
			"label": "Not Generated",
			"value": "1"
		}
	],
	"entry_open_invo_type": [{
			"id": "1192",
			"label": "E-Invoice",
			"value": "0"
		},
		{
			"id": "1193",
			"label": "Mailed Invoice",
			"value": "1"
		}
	],
	"restriction_type": [{
			"id": "1303",
			"label": "Restricted Area",
			"value": "0"
		},
		{
			"id": "1304",
			"label": "Permitted Area",
			"value": "1"
		}
	],
	"indust_weight_unit": [{
			"id": "1487",
			"label": "Jin (0.5kg)",
			"value": "0"
		},
		{
			"id": "1488",
			"label": "Kilogram",
			"value": "1"
		},
		{
			"id": "1489",
			"label": "Ton",
			"value": "2"
		}
	],
	"farm_source_type": [{
			"id": "1389",
			"label": "External Procurement",
			"value": "0"
		},
		{
			"id": "1390",
			"label": "Self-Breeding",
			"value": "1"
		}
	],
	"module_type": [{
			"id": "1335",
			"label": "Rich Text",
			"value": "0"
		},
		{
			"id": "1336",
			"label": "Image",
			"value": "1"
		},
		{
			"id": "1337",
			"label": "Video",
			"value": "2"
		},
		{
			"id": "1338",
			"label": "Link",
			"value": "8"
		},
		{
			"id": "1339",
			"label": "External Link",
			"value": "9"
		}
	],
	"invo_catg_type": [{
			"id": "1190",
			"label": "Personal",
			"value": "0"
		},
		{
			"id": "1191",
			"label": "Enterprise",
			"value": "1"
		}
	],
	"certification_type": [{
			"id": "1483",
			"label": "Link Address",
			"value": "0"
		},
		{
			"id": "1484",
			"label": "PDF Attachment",
			"value": "1"
		}
	],
	"use_car_type": [{
			"id": "1407",
			"label": "Full Truck",
			"value": "0"
		},
		{
			"id": "1408",
			"label": "Shared Truck",
			"value": "1"
		}
	],
	"pay_state_type": [{
			"id": "1080",
			"label": "Unpaid",
			"value": "0"
		},
		{
			"id": "1081",
			"label": "Paid",
			"value": "1"
		},
		{
			"id": "1081",
			"label": "Pending Final Payment",
			"value": "2"
		}
	],
	"invalid_type": [{
			"id": "1111",
			"label": "Valid",
			"value": "0"
		},
		{
			"id": "1112",
			"label": "Invalid",
			"value": "1"
		}
	],
	"manage": [{
			"id": "1523",
			"label": "Enterprise Self-Built",
			"value": "1"
		},
		{
			"id": "1524",
			"label": "Planting Cooperative",
			"value": "2"
		},
		{
			"id": "1525",
			"label": "Large-Scale Grower",
			"value": "3"
		},
		{
			"id": "1526",
			"label": "Small-Scale Grower",
			"value": "4"
		}
	],
	"service_type": [{
			"id": "1048",
			"label": "Internal Service",
			"value": "0"
		},
		{
			"id": "1049",
			"label": "External Service",
			"value": "1"
		}
	],
	"product_type": [{
			"id": "1210",
			"label": "Order Financing",
			"value": "0"
		},
		{
			"id": "1211",
			"label": "Credit Financing",
			"value": "1"
		},
		{
			"id": "1212",
			"label": "Supply Chain Financing",
			"value": "2"
		},
		{
			"id": "1213",
			"label": "Inventory Financing",
			"value": "3"
		},
		{
			"id": "1214",
			"label": "Accounts Receivable",
			"value": "4"
		},
		{
			"id": "1215",
			"label": "Equity Financing",
			"value": "5"
		},
		{
			"id": "1216",
			"label": "Mortgage Financing",
			"value": "6"
		},
		{
			"id": "1217",
			"label": "Insurance Financing",
			"value": "7"
		}
	],
	"sms_template_type": [{
			"id": "1002",
			"label": "resetPwd",
			"value": "[Agricultural Industry Service Cloud] Dear {0}, your password has been reset; The new password is {1}. You can now log in using your current username and the new password."
		},
		{
			"id": "1003",
			"label": "subAccount",
			"value": "[Agricultural Industry Service Cloud] {0} employee account; Employee Name: {1}, Username: {2}, Password: {3}"
		},
		{
			"id": "1004",
			"label": "smsCode",
			"value": "[Agricultural Industry Service Cloud] (Verification code: {0}, valid for {1} minutes) For your account security, please do not share this code. If you didn't request this, please ignore."
		},
		{
			"id": "1005",
			"label": "userRegSmsMsg",
			"value": "[Agricultural Industry Service Cloud] Congratulations! Your account registration is successful! Thank you for choosing our e-commerce platform. We look forward to exploring business opportunities and achieving success together!"
		},
		{
			"id": "1006",
			"label": "authPass",
			"value": "[Agricultural Industry Service Cloud] Dear user, your enterprise certification has been approved. You can now enjoy more business opportunities and privileges. Thank you for your cooperation!"
		},
		{
			"id": "1007",
			"label": "authReject",
			"value": "[Agricultural Industry Service Cloud] Dear user, your enterprise certification was not approved. Please review and update the relevant materials before reapplying. Thank you for your cooperation!"
		}
	],
	"invo_type": [{
			"id": "1188",
			"label": "Regular Invoice",
			"value": "0"
		},
		{
			"id": "1189",
			"label": "VAT Special Invoice",
			"value": "1"
		}
	],
	"entp_type": [{
			"id": "1037",
			"label": "Planting Enterprise",
			"value": "1"
		},
		{
			"id": "1038",
			"label": "Breeding Enterprise",
			"value": "2"
		},
		{
			"id": "1039",
			"label": "Cooperative",
			"value": "3"
		},
		{
			"id": "1040",
			"label": "Family Farm",
			"value": "4"
		},
		{
			"id": "1041",
			"label": "Processing Enterprise",
			"value": "5"
		},
		{
			"id": "1042",
			"label": "Logistics Enterprise",
			"value": "6"
		},
		{
			"id": "1043",
			"label": "Warehousing Enterprise",
			"value": "7"
		},
		{
			"id": "1044",
			"label": "Sales Enterprise",
			"value": "8"
		},
		{
			"id": "1045",
			"label": "Other Types",
			"value": "9"
		}
	],
	"order_return_type": [{
			"id": "1078",
			"label": "Full Order Refund",
			"value": "0"
		},
		{
			"id": "1079",
			"label": "Single Product Refund",
			"value": "1"
		}
	],
	"base_certification": [{
			"id": "1493",
			"label": "Organic Certified Base",
			"value": "0"
		},
		{
			"id": "1494",
			"label": "Green Certified Base",
			"value": "1"
		},
		{
			"id": "1495",
			"label": "Premium Demonstration Garden",
			"value": "2"
		},
		{
			"id": "1496",
			"label": "Other",
			"value": "3"
		}
	],
	"qms_report_status": [{
			"id": "1326",
			"label": "Not Generated",
			"value": "0"
		},
		{
			"id": "1327",
			"label": "Generated",
			"value": "1"
		}
	],
	"equ_type": [{
			"id": "1296",
			"label": "Video Surveillance Equipment",
			"value": "0"
		},
		{
			"id": "1297",
			"label": "Meteorological Equipment",
			"value": "1"
		},
		{
			"id": "1298",
			"label": "Soil Monitoring Equipment",
			"value": "2"
		},
		{
			"id": "1299",
			"label": "Pest Monitoring Equipment",
			"value": "3"
		},
		{
			"id": "1300",
			"label": "Gas Monitoring Equipment",
			"value": "4"
		}
	],
	"output_unit": [{
			"id": "1548",
			"label": "Jin (0.5kg)",
			"value": "0"
		},
		{
			"id": "1549",
			"label": "Kilogram",
			"value": "1"
		},
		{
			"id": "1550",
			"label": "Ton",
			"value": "2"
		},
		{
			"id": "1551",
			"label": "Piece",
			"value": "3"
		},
		{
			"id": "1552",
			"label": "Unit",
			"value": "4"
		},
		{
			"id": "1553",
			"label": "Box",
			"value": "5"
		},
		{
			"id": "1554",
			"label": "Bag",
			"value": "6"
		}
	],
	"order_state_type_b2b": [{
			"id": "1061",
			"label": "Pending Confirmation",
			"value": "0"
		},
		{
			"id": "1062",
			"label": "Pending Payment",
			"value": "1"
		},
		{
			"id": "1063",
			"label": "Pending Shipment",
			"value": "2"
		},
		{
			"id": "1064",
			"label": "Pending Receipt",
			"value": "3"
		},
		{
			"id": "1065",
			"label": "Completed",
			"value": "4"
		},
		{
			"id": "1066",
			"label": "Canceled",
			"value": "5"
		},
		{
			"id": "1068",
			"label": "Pending Stock Preparation",
			"value": "7"
		},
		{
			"id": "1069",
			"label": "Pending Pickup",
			"value": "8"
		}
	],
	"refund_appl_state_type_b2b": [{
			"id": "1081",
			"label": "Pending Review",
			"value": "0"
		},
		{
			"id": "1083",
			"label": "Rejected",
			"value": "2"
		},
		{
			"id": "1084",
			"label": "Completed",
			"value": "3"
		},
		{
			"id": "1085",
			"label": "Canceled",
			"value": "4"
		}
	],
	"expo_industry_category": [{
		"id": "1596",
		"label": "Planters & Farm Owners",
		"value": "0"
	}, {
		"id": "1597",
		"label": "Agricultural Cooperatives",
		"value": "1"
	}, {
		"id": "1598",
		"label": "Food Processing Enterprises",
		"value": "2"
	}, {
		"id": "1599",
		"label": "Research & Technical Institutions",
		"value": "3"
	}, {
		"id": "1600",
		"label": "Government & Industry Organizations",
		"value": "4"
	}, {
		"id": "1601",
		"label": "Other Industries",
		"value": "5"
	}],
	"expo_join_purpose": [{
		"id": "1602",
		"label": "Seeking new trade opportunities/purchasing products",
		"value": "0"
	}, {
		"id": "1603",
		"label": "Exploring new cooperation opportunities",
		"value": "1"
	}, {
		"id": "1604",
		"label": "Gathering industry trends/market information",
		"value": "2"
	}, {
		"id": "1605",
		"label": "Attending concurrent seminars/lectures",
		"value": "3"
	}, {
		"id": "1606",
		"label": "Evaluating exhibition for future participation",
		"value": "4"
	}, {
		"id": "1607",
		"label": "Others",
		"value": "5"
	}],
	"expo_company_property": [{
		"id": "1587",
		"label": "State-owned Enterprise",
		"value": "0"
	}, {
		"id": "1588",
		"label": "Collective-owned Enterprise",
		"value": "1"
	}, {
		"id": "1589",
		"label": "Joint Operation Enterprise",
		"value": "2"
	}, {
		"id": "1590",
		"label": "Foreign-funded Enterprise",
		"value": "3"
	}, {
		"id": "1591",
		"label": "Private Enterprise",
		"value": "4"
	}],
	"expo_company_type": [{
		"id": "1582",
		"label": "Limited Liability Company",
		"value": "0"
	}, {
		"id": "1583",
		"label": "Joint Stock Company",
		"value": "1"
	}, {
		"id": "1584",
		"label": "Limited Partnership",
		"value": "2"
	}, {
		"id": "1585",
		"label": "Wholly Foreign-owned Enterprise",
		"value": "3"
	}, {
		"id": "1586",
		"label": "Sole Proprietorship",
		"value": "4"
	}],
	"expo_Intended_area": [{
		"id": "1575",
		"label": "Standard Booth 9m²",
		"value": "0"
	}, {
		"id": "1576",
		"label": "Standard Booth 18m²",
		"value": "1"
	}, {
		"id": "1577",
		"label": "Raw Space 36m²",
		"value": "2"
	}, {
		"id": "1578",
		"label": "Raw Space 72m²",
		"value": "3"
	}, {
		"id": "1579",
		"label": "Raw Space 108m²",
		"value": "4"
	}, {
		"id": "1580",
		"label": "Raw Space 126m²",
		"value": "5"
	}, {
		"id": "1581",
		"label": "Others",
		"value": "6"
	}],
	"expo_business_status": [{
		"id": "1592",
		"label": "Offline",
		"value": "0"
	}, {
		"id": "1593",
		"label": "Online",
		"value": "1"
	}],
	"expo_info_status": [{
		"id": "1594",
		"label": "Offline",
		"value": "0"
	}, {
		"id": "1595",
		"label": "Online",
		"value": "1"
	}],
	"expo_scan_status": [{
		"id": "1608",
		"label": "Not Scanned",
		"value": "0"
	}, {
		"id": "1609",
		"label": "Scanned",
		"value": "1"
	}],
	"product_type": [{
		"id": "1557",
		"label": "Commercial Premium",
		"value": "0"
	}, {
		"id": "1558",
		"label": "Supply Guarantee",
		"value": "1"
	}, {
		"id": "1559",
		"label": "Geographical Indication Products",
		"value": "2"
	}, {
		"id": "1560",
		"label": "Special Selected",
		"value": "3"
	}, {
		"id": "1561",
		"label": "Export Premium",
		"value": "4"
	}],
	"supply_cycle_type": [{
		"id": "1562",
		"label": "Year-round Supply",
		"value": "0"
	}, {
		"id": "1563",
		"label": "January",
		"value": "1"
	}, {
		"id": "1564",
		"label": "February",
		"value": "2"
	}, {
		"id": "1565",
		"label": "March",
		"value": "3"
	}, {
		"id": "1566",
		"label": "April",
		"value": "4"
	}, {
		"id": "1567",
		"label": "May",
		"value": "5"
	}, {
		"id": "1568",
		"label": "June",
		"value": "6"
	}, {
		"id": "1569",
		"label": "July",
		"value": "7"
	}, {
		"id": "1570",
		"label": "August",
		"value": "8"
	}, {
		"id": "1571",
		"label": "September",
		"value": "9"
	}, {
		"id": "1572",
		"label": "October",
		"value": "10"
	}, {
		"id": "1573",
		"label": "November",
		"value": "11"
	}, {
		"id": "1574",
		"label": "December",
		"value": "12"
	}, ]
}
module.exports = DataDict